module.exports = __webpack_public_path__ + "img/it.0e58d527.svg";